import axios from "axios";

const state = {
  facilities: [],
  totals: null
};

const actions = {
  getAllData: ({ commit }) => {
    return axios.get(`/dashboard`)
      .then((resp) => {
        commit("setFacilities", resp.data.facilities);
        commit("setTotals", resp.data.totals);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getFilteredReservationStatistics: ({ commit }, payload) => {
    return axios.get(`/dashboard`, {
      params: payload
    })
      .then((resp) => {
        commit("setFacilities", resp.data.facilities);
        commit("setTotals", resp.data.totals);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  downloadReservationCsv: () => {
    return axios.get(`/dashboard/download-reservations`, {
      responseType: "blob"
    })
      .then((resp) => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reservations.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return resp;
      })
      .catch((err) => {
        console.log("could not download csv, error: ", err.response);
        return Promise.reject(err);
      });
  }
};

const mutations = {
  setFacilities: (state, facilities) => {
    state.facilities = facilities;
  },
  setTotals: (state, totals) => {
    state.totals = totals;
  }
};

export default {
  state,
  actions,
  mutations
};
